import { render, staticRenderFns } from "./OnboardingStatusChip.vue?vue&type=template&id=58362db9&"
import script from "./OnboardingStatusChip.vue?vue&type=script&lang=js&"
export * from "./OnboardingStatusChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports